export default __webpack_public_path__ + "static/media/abb-knx.070dce52.webp";